import { render, staticRenderFns } from "./ChevronUpDownIcon.vue?vue&type=template&id=07ef4b80&"
import script from "./ChevronUpDownIcon.vue?vue&type=script&lang=js&"
export * from "./ChevronUpDownIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports